import Checkbox from 'modules/common/components/Checkbox';
import {
  discountItemTypeFilter,
  discountLifecycleStatus,
  discountStockFilter,
  PRODUCT_TYPE,
} from '../../constants';
import discountsStrings from '../../strings';
import {
  CreateBundleOutlineButton,
  CreateOfferPlusIcon,
  CreateOfferPrimaryButton,
  DiscountFilterGroup,
  DiscountFilterLabel,
  DiscountFilterPill,
  DiscountFiltersSection,
  DiscountFilterIcon,
  DiscountItemTypeFilterRow,
  DiscountStatusFilterRow,
  DiscountStockCheckboxes,
  DiscountStockFilterLabel,
  DiscountStockFilterRow,
  DiscountToolbarRight,
  FiltersToolbarButton,
} from '../../views/Discounts.style';

const STATUS_OPTIONS = [
  { id: discountLifecycleStatus.All, label: discountsStrings.statusAll },
  { id: discountLifecycleStatus.Active, label: discountsStrings.statusActive },
  { id: discountLifecycleStatus.Scheduled, label: discountsStrings.statusScheduled },
  { id: discountLifecycleStatus.Stopped, label: discountsStrings.statusStopped },
  { id: discountLifecycleStatus.Completed, label: discountsStrings.statusCompleted },
];

const ITEM_TYPE_OPTIONS = [
  { id: discountItemTypeFilter.All, label: discountsStrings.itemTypeAll },
  { id: PRODUCT_TYPE.Product, label: discountsStrings.itemTypeProduct },
  { id: PRODUCT_TYPE.Bundle, label: discountsStrings.itemTypeBundle },
];

const STOCK_OPTIONS = [
  { id: discountStockFilter.All, label: discountsStrings.stockAll },
  { id: discountStockFilter.InStock, label: discountsStrings.stockInStock },
  { id: discountStockFilter.OutOfStock, label: discountsStrings.stockOutOfStock },
];

interface DiscountFiltersProps {
  statusFilter: number;
  stockFilter: number;
  itemTypeFilter: number;
  onStatusChange: (value: number) => void;
  onStockChange: (value: number) => void;
  onItemTypeChange: (value: number) => void;
  onCreateOffer: () => void;
  onCreateBundle: () => void;
  onOpenAdvancedFilters: () => void;
}

const DiscountFilters = ({
  statusFilter,
  stockFilter,
  itemTypeFilter,
  onStatusChange,
  onStockChange,
  onItemTypeChange,
  onCreateOffer,
  onCreateBundle,
  onOpenAdvancedFilters,
}: DiscountFiltersProps) => (
  <DiscountFiltersSection>
    <DiscountItemTypeFilterRow>
      <DiscountFilterGroup>
        {ITEM_TYPE_OPTIONS.map(option => (
          <DiscountFilterPill
            key={option.id}
            type="button"
            $active={itemTypeFilter === option.id}
            onClick={() => onItemTypeChange(option.id)}
          >
            {option.label}
          </DiscountFilterPill>
        ))}
      </DiscountFilterGroup>

      <DiscountToolbarRight>
        <CreateBundleOutlineButton type="button" onClick={onCreateBundle}>
          <CreateOfferPlusIcon>+</CreateOfferPlusIcon>
          {discountsStrings.createBundleBtn}
        </CreateBundleOutlineButton>
        <CreateOfferPrimaryButton type="button" onClick={onCreateOffer}>
          <CreateOfferPlusIcon>+</CreateOfferPlusIcon>
          {discountsStrings.createOfferBtn}
        </CreateOfferPrimaryButton>
        <FiltersToolbarButton type="button" onClick={onOpenAdvancedFilters}>
          {discountsStrings.filtersBtn}
        </FiltersToolbarButton>
      </DiscountToolbarRight>
    </DiscountItemTypeFilterRow>

    <DiscountStatusFilterRow>
      <DiscountFilterGroup>
        <DiscountFilterLabel>{discountsStrings.exploreByLabel}</DiscountFilterLabel>
        {STATUS_OPTIONS.map(option => (
          <DiscountFilterPill
            key={option.id}
            type="button"
            $active={statusFilter === option.id}
            onClick={() => onStatusChange(option.id)}
          >
            {option.label}
          </DiscountFilterPill>
        ))}
      </DiscountFilterGroup>
    </DiscountStatusFilterRow>

    <DiscountStockFilterRow>
      <DiscountStockFilterLabel>
        <DiscountFilterIcon />
        {discountsStrings.stockFilterLabel}:
      </DiscountStockFilterLabel>
      <DiscountStockCheckboxes>
        {STOCK_OPTIONS.map(option => (
          <Checkbox
            key={option.id}
            checkboxObj={{ key: option.id, name: option.label }}
            checked={stockFilter === option.id}
            handleCheckboxClick={onStockChange}
          />
        ))}
      </DiscountStockCheckboxes>
    </DiscountStockFilterRow>
  </DiscountFiltersSection>
);

export default DiscountFilters;
